import { ChangeDetectionStrategy, Component, Input, OnInit, Self, TemplateRef } from '@angular/core';
import { combineLatest, map, takeUntil } from 'rxjs';
import { DataSourceControlService } from '../data-source-utils/data-source-control.service';
import { FormControlService } from '../form-control.service';
import createControlValueAccessorProvider from '../utils/create-control-value-accessor-provider';

import { filterAllTruthyInTuple } from 'core/rx-js';
import { ControlValueAccessorImpl } from '../ng-material-impl/control-value-accessor.impl';
import { AutocompleteFormControlService } from './autocomplete-form-control.service';

@Component({
  selector: 'ss-autocomplete-form-control',
  templateUrl: './autocomplete-form-control.component.html',
  styleUrls: ['./autocomplete-form-control.component.css'],
  providers: [
    AutocompleteFormControlService,
    FormControlService,
    createControlValueAccessorProvider(AutocompleteFormControlComponent),
    { provide: DataSourceControlService, useExisting: AutocompleteFormControlService }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteFormControlComponent extends ControlValueAccessorImpl<string | number> implements OnInit {

  private _matOptionTemplate!: TemplateRef<any>
  @Input() get matOptionTemplate() {
    return this._matOptionTemplate
  }
  set matOptionTemplate(value: TemplateRef<any>) {
    this._matOptionTemplate = value;
    this._autocompleteFormControlService.matOptionTemplateRefSubject.next(this.matOptionTemplate);
  }

  readonly selectedItemSubject = this._autocompleteFormControlService.selectedItemSubject;
  readonly fetchingSubject = this._autocompleteFormControlService.fetchingSubject;
  readonly hintWithSubject = this._autocompleteFormControlService.hintWithSubject;

  readonly hintObs = combineLatest([
    this.selectedItemSubject,
    this.hintWithSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      takeUntil(this._destroy),
      map(([selectedItem, hintWith]) => selectedItem[hintWith || ''])
    )

  constructor(
    @Self() private _autocompleteFormControlService: AutocompleteFormControlService,
  ) {

    super()
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
  }



}

